import React, { useCallback, useEffect, useMemo, useState } from "react";
import "./styles.less";
import classNames from "classnames";

export const ApplicationContents = ({ navList, listHeight, childHeight }) => {
  const [documrntScrollTop, setDocumrntScrollTop] = useState();
  const [currentKey, setCurrentKey] = useState("intro");
  const handleScroll = (id) => {
    const el = document.querySelector(`#${id}`);
    // el && el.scrollIntoView();
    el &&
      el.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      });
  };

  const scrollHandler = useCallback(() => {
    const scrollTop = document.documentElement.scrollTop;
    setDocumrntScrollTop(scrollTop);
    if (scrollTop > 410 && scrollTop < 550) {
      setCurrentKey("intro");
    } else if (scrollTop > 1000 && scrollTop < 1100) {
      setCurrentKey("platform");
    } else if (scrollTop > 1500 && scrollTop < 1600) {
      setCurrentKey("step");
    } else if (scrollTop > listHeight && scrollTop < 5100) {
      setCurrentKey("integrate");
    }
  }, [listHeight]);
  useEffect(() => {
    console.log(documrntScrollTop);
    window.addEventListener("scroll", scrollHandler);
    return () => {
      window.removeEventListener("scroll", scrollHandler);
    };
  }, [documrntScrollTop, scrollHandler]);
  const clsContentsBox = classNames({
    "application-contents-box": true,
    fixed: documrntScrollTop > 460 && documrntScrollTop <= listHeight,
    relative: documrntScrollTop > listHeight,
  });
  return (
    <div className="application-contents-warp">
      <div className={clsContentsBox}>
        <div className="application-contents">
          {navList.map((item, index) => {
            const clsContentsItem = classNames({
              "contents-item": true,
              checked: currentKey === item.key,
            });
            return (
              <div
                key={index}
                className={clsContentsItem}
                style={
                  documrntScrollTop > listHeight
                    ? { top: listHeight + "px", position: "relative" }
                    : {}
                }
                onClick={() => {
                  handleScroll(item.key);
                  setCurrentKey(item.key);
                }}
              >
                {item.label}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
